import { createSelector } from "reselect";
import { getAvailableTeams } from "~/Redux/AvailableUsers";
import { createSortedUsersSelector } from "~/Redux/AvailableUsers/users/selectors";
import { ProjectOrTask, RootMessageBoardState } from "../types";
import { getKey } from "../utils/getKey";

export const getMentionsLoaded = (state: RootMessageBoardState, request: ProjectOrTask): boolean =>
    !!state?.messageBoard?.mentions?.[getKey(request)];

export const getMentionIds = (state: RootMessageBoardState, request: ProjectOrTask): number[] =>
    state?.messageBoard?.mentions[getKey(request)]?.userIds;

export const getMentions = createSortedUsersSelector(getMentionIds);

const emptyEmailOnlyMentions = {};
export const getEmailOnlyMentions = (state: RootMessageBoardState, request: ProjectOrTask) =>
    (request && state?.messageBoard?.mentions?.[getKey(request)]?.emailOnlyMentions) ?? emptyEmailOnlyMentions;

export const getTeamMentions = createSelector(getAvailableTeams, getMentionIds, (availableTeams, mentionsIds) =>
    mentionsIds?.length && availableTeams
        ? Object.values(availableTeams).filter(x => x.Users.some(u => mentionsIds.includes(u)))
        : []
);
